import { helper } from '@ember/component/helper';
import _textDeltaIsEmpty from 'scaleflow/utils/text-delta-is-empty';

export default helper(function textDeltaIsEmpty([text_delta]) {
  return _textDeltaIsEmpty(text_delta);
});
